import type {
  SiteCreateApiData,
  SiteCreateApiResponses,
  SiteGetApiData,
  SiteGetApiResponses,
  SiteListApiData,
  SiteListApiResponses,
  SitePatchApiData,
  SitePatchApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getSiteUrls = {
  getPaginatedSites: dataEndpoint<SiteListApiData, SiteListApiResponses>({
    getUrl: (queryParams) => apiUrl('sites/', queryParams)
  }),
  getSite: dataEndpoint<SiteGetApiData, SiteGetApiResponses>({
    getUrl: ({ siteId }) => apiUrl(`sites/${siteId}/`)
  }),
  patchSite: responseEndpoint<SitePatchApiData, SitePatchApiResponses>({
    getUrl: ({ siteId }) => apiUrl(`sites/${siteId}/`),
    getBody: (data) => data
  }),
  postSite: responseEndpoint<SiteCreateApiData, SiteCreateApiResponses>({
    getUrl: () => apiUrl('sites/'),
    getBody: (data) => data
  })
};
